module.exports = __webpack_public_path__ + "img/middenspanning.20ca4e4e.png";